import React from 'react';
import './Legal.css';

function Terms() {
  return (
    <div className="legal-page">
      <section className="legal-hero">
        <div className="legal-bg-elements">
          <div className="legal-glow legal-glow-1"></div>
          <div className="legal-glow legal-glow-2"></div>
        </div>
        <div className="container">
          <h1>Terms of Service</h1>
          <p className="legal-updated">Last updated: January 2025</p>
        </div>
      </section>

      <section className="section legal-content-section">
        <div className="container">
          <div className="legal-content">
            <div className="legal-intro">
              <p>
                Welcome to Wordalanche! These Terms of Service ("Terms") govern your use of the Wordalanche
                mobile application ("App") operated by Play Best Entertainment, LLC ("Company", "we", "us", or "our").
              </p>
              <p>
                By downloading, installing, or using the App, you agree to be bound by these Terms. If you
                do not agree to these Terms, please do not use the App.
              </p>
            </div>

            <div className="legal-section">
              <h2>1. Acceptance of Terms</h2>
              <p>
                By accessing or using Wordalanche, you confirm that you are at least 13 years of age (or the
                minimum age required in your jurisdiction) and have the legal capacity to enter into these Terms.
                If you are under 18, you represent that your parent or legal guardian has reviewed and agreed
                to these Terms on your behalf.
              </p>
            </div>

            <div className="legal-section">
              <h2>2. License to Use</h2>
              <p>
                Subject to your compliance with these Terms, we grant you a limited, non-exclusive,
                non-transferable, revocable license to download, install, and use the App on your personal
                mobile device for your personal, non-commercial use.
              </p>
              <p>You may not:</p>
              <ul>
                <li>Copy, modify, or distribute the App or its content</li>
                <li>Reverse engineer, decompile, or disassemble the App</li>
                <li>Remove any copyright or proprietary notices</li>
                <li>Use the App for any illegal or unauthorized purpose</li>
                <li>Attempt to gain unauthorized access to the App's systems or networks</li>
                <li>Use any automated systems or software to extract data from the App</li>
              </ul>
            </div>

            <div className="legal-section">
              <h2>3. User Accounts</h2>
              <p>
                Some features of the App may require you to create an account or sign in through a third-party
                service (such as Apple Game Center). You are responsible for maintaining the confidentiality of
                your account credentials and for all activities that occur under your account.
              </p>
              <p>
                You agree to provide accurate and complete information when creating an account and to update
                your information as necessary to keep it accurate and complete.
              </p>
            </div>

            <div className="legal-section">
              <h2>4. In-App Purchases</h2>
              <p>
                Wordalanche may offer in-app purchases for virtual items such as gems, power-ups, or other
                digital content. All purchases are final and non-refundable, except as required by applicable law.
              </p>
              <p>
                Virtual items have no monetary value and cannot be exchanged for real currency. We reserve the
                right to modify, manage, or eliminate virtual items at any time.
              </p>
              <p>
                Purchases are processed through the Apple App Store, and you agree to their terms of service
                for any transactions.
              </p>
            </div>

            <div className="legal-section">
              <h2>5. User Conduct</h2>
              <p>You agree not to:</p>
              <ul>
                <li>Use cheats, exploits, automation software, or any unauthorized third-party tools</li>
                <li>Interfere with or disrupt the App or servers</li>
                <li>Harass, abuse, or harm other users</li>
                <li>Impersonate any person or entity</li>
                <li>Upload or transmit viruses or malicious code</li>
                <li>Engage in any activity that violates applicable laws or regulations</li>
              </ul>
            </div>

            <div className="legal-section">
              <h2>6. Intellectual Property</h2>
              <p>
                The App and all its content, features, and functionality (including but not limited to text,
                graphics, logos, icons, images, audio clips, and software) are owned by Play Best Entertainment, LLC
                and are protected by copyright, trademark, and other intellectual property laws.
              </p>
              <p>
                "Wordalanche", the Wordalanche logo, and related marks are trademarks of Play Best Entertainment, LLC.
                You may not use these marks without our prior written permission.
              </p>
            </div>

            <div className="legal-section">
              <h2>7. Third-Party Services</h2>
              <p>
                The App may contain links to or integrations with third-party services, including advertising
                networks and analytics providers. We are not responsible for the content, privacy practices,
                or terms of any third-party services. Your use of such services is at your own risk.
              </p>
            </div>

            <div className="legal-section">
              <h2>8. Disclaimers</h2>
              <p>
                THE APP IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS
                OR IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
                PURPOSE, AND NON-INFRINGEMENT.
              </p>
              <p>
                We do not warrant that the App will be uninterrupted, error-free, or secure, or that any defects
                will be corrected.
              </p>
            </div>

            <div className="legal-section">
              <h2>9. Limitation of Liability</h2>
              <p>
                TO THE MAXIMUM EXTENT PERMITTED BY LAW, PLAY BEST ENTERTAINMENT, LLC SHALL NOT BE LIABLE FOR
                ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS
                OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL, OR
                OTHER INTANGIBLE LOSSES RESULTING FROM:
              </p>
              <ul>
                <li>Your use or inability to use the App</li>
                <li>Any unauthorized access to or use of our servers</li>
                <li>Any bugs, viruses, or other harmful code transmitted through the App</li>
                <li>Any errors or omissions in any content</li>
              </ul>
            </div>

            <div className="legal-section">
              <h2>10. Indemnification</h2>
              <p>
                You agree to indemnify and hold harmless Play Best Entertainment, LLC, its officers, directors,
                employees, and agents from any claims, damages, losses, liabilities, and expenses (including
                attorneys' fees) arising out of your use of the App or violation of these Terms.
              </p>
            </div>

            <div className="legal-section">
              <h2>11. Termination</h2>
              <p>
                We may terminate or suspend your access to the App at any time, without prior notice or liability,
                for any reason, including if you breach these Terms. Upon termination, your license to use the
                App will immediately cease.
              </p>
            </div>

            <div className="legal-section">
              <h2>12. Changes to Terms</h2>
              <p>
                We reserve the right to modify these Terms at any time. We will notify you of significant changes
                by posting the updated Terms within the App or on our website. Your continued use of the App
                after such changes constitutes acceptance of the new Terms.
              </p>
            </div>

            <div className="legal-section">
              <h2>13. Governing Law</h2>
              <p>
                These Terms shall be governed by and construed in accordance with the laws of the State of
                Delaware, without regard to its conflict of law provisions. Any disputes arising from these
                Terms or your use of the App shall be resolved in the courts located in Delaware.
              </p>
            </div>

            <div className="legal-section">
              <h2>14. Severability</h2>
              <p>
                If any provision of these Terms is found to be unenforceable, the remaining provisions will
                continue in full force and effect.
              </p>
            </div>

            <div className="legal-section">
              <h2>15. Contact Information</h2>
              <p>
                If you have any questions about these Terms, please contact us at:
              </p>
              <div className="contact-info">
                <p><strong>Play Best Entertainment, LLC</strong></p>
                <p>Email: <a href="mailto:legal@playbestentertainment.com">legal@playbestentertainment.com</a></p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Terms;
